import React from 'react';
import { TokenExpirationTimer } from '../../../services/auth';
import { Container } from './styles';

function FooterPage() {
  return (
    <Container>
      <div>{new Date().getFullYear()} © Unimed Fesp | Sistema MovCad</div>
      <div>
        <TokenExpirationTimer />
      </div>
    </Container>
  );
}

export default FooterPage;
